import styled from 'styled-components';

export const GeoMapContainer = styled.div`
width:100%;
margin-left:0em;
margin-top:1em;
// margin-right:3em;
// overflow:scroll;
`;